import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import InactiveReasonAnimation from '@/components/InactiveReasonAnimation';
import {
  formatInactiveExpectedAvailability,
  getInactiveReasonAccentClass,
  getInactiveReasonDialogFallback,
  getInactiveReasonDialogMessage,
  getInactiveReasonDialogTitle,
  normalizeInactiveReason,
} from '@/utils/applicationInactiveStatus';

/**
 * Modal affiché lorsqu'un utilisateur tente d'ouvrir une application désactivée.
 */
export default function InactiveApplicationDialog({ open, onOpenChange, app }) {
  const reason = normalizeInactiveReason(app?.inactive_reason);
  const etaLabel = formatInactiveExpectedAvailability(app);
  const fallback = getInactiveReasonDialogFallback(reason, Boolean(etaLabel));

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="inactive-app-dialog"
        className="overflow-hidden dark:border-gray-700 dark:bg-gray-800 sm:max-w-md"
      >
        <div
          className={`mb-4 flex h-32 items-center justify-center rounded-xl bg-gradient-to-b ${getInactiveReasonAccentClass(reason)}`}
        >
          <InactiveReasonAnimation reason={reason} />
        </div>
        <DialogHeader>
          <DialogTitle className="text-center dark:text-white">
            {getInactiveReasonDialogTitle(reason)}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm text-gray-600 dark:text-gray-300">
          <p className="text-center">
            L&apos;application{' '}
            <strong className="text-gray-900 dark:text-white">{app?.name || '—'}</strong>{' '}
            {getInactiveReasonDialogMessage(reason)}
          </p>
          {etaLabel && (
            <p className="rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 dark:border-gray-600 dark:bg-gray-700/50">
              <span className="font-medium text-gray-800 dark:text-gray-200">Disponibilité estimée : </span>
              {etaLabel}
            </p>
          )}
          {fallback && (
            <p className="text-center text-gray-500 dark:text-gray-400">{fallback}</p>
          )}
        </div>
        <Button
          type="button"
          variant="outline"
          className="mt-2 w-full dark:border-gray-600 dark:text-gray-200"
          onClick={() => onOpenChange(false)}
        >
          Fermer
        </Button>
      </DialogContent>
    </Dialog>
  );
}
